import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  lastUpdateStatusBar: {
    background: theme.warningBGColor,
    fontSize: theme.textFontSize,
    padding: '10px',
    color: theme.warningTextColorDispatch,
    fontWeight: 500,
    marginTop: 8,
    borderRadius: '4px'
  }
});

const MoveProWarning = ({ existingManifest, newManifest, classes }) => {
  return (
    <div className={classes.lastUpdateStatusBar}>
      {`Remove pro from manifest# ${existingManifest} and Add it to manifest# ${newManifest}`}
    </div>
  );
};

export default withStyles(styles)(MoveProWarning);
